import { z } from "zod";

export const facadeReportDefaultsSchema = z.object({
  feedback: z.string().max(10000),
}).strict();
